import useTheme from '@hooks/useTheme';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import useIsClinicianSubdomain from '@hooks/useIsClinicianSubdomain';
import { AXA_LOGO, NEW_HBS_LOGO } from '@lib/context/themes';

const StyledAuthHeader = styled.div`
  min-height: 80px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
`;

const getLogoImg = ({ src, alt }: { src?: string; alt: string }) => {
  if (!src) return null;
  return <img height={55} src={src} alt={alt} />;
};

const AuthHeader = ({ HeaderLeft }: { HeaderLeft?: React.ReactNode }) => {
  const { t } = useTranslation('common');
  const { theme, isHBSTheme, isThemeResolved } = useTheme();
  const isClinicianSubdomain = useIsClinicianSubdomain();

  const getLeftLogo = () => {
    if (!isThemeResolved) return null;

    if (isHBSTheme) {
      return getLogoImg({
        src: isClinicianSubdomain ? NEW_HBS_LOGO : AXA_LOGO,
        alt: t(`${isClinicianSubdomain ? t('HBS') : t('AXA')} logo`)
      });
    }

    return getLogoImg({ src: theme?.logo, alt: theme?.altText?.toUpperCase() ?? t('logo') });
  };

  const getRightLogo = () => {
    if (!isThemeResolved) return null;
    if (isHBSTheme && isClinicianSubdomain) return null;

    return getLogoImg({ src: NEW_HBS_LOGO, alt: t('HBS logo') });
  };

  const leftLogo = getLeftLogo();
  const rightLogo = getRightLogo();

  return (
    <StyledAuthHeader>
      {HeaderLeft ?? leftLogo}
      {rightLogo}
    </StyledAuthHeader>
  );
};

export default AuthHeader;
